// extracted by mini-css-extract-plugin
export default {"MainLayout":"mainLayout_MainLayout__Q+VPx","wrapper":"mainLayout_wrapper__qaE94","ds-page-in":"mainLayout_ds-page-in__QrVo-"};